import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Calculator, MessageCircle, Package, Zap, DollarSign } from 'lucide-react';

const NewHowItWorks = () => {
  const ctaLink = "https://calendly.com/davwaysolution/review";
  
  const steps = [
    {
      step: "1",
      icon: Calculator,
      title: "Calculate Your Savings",
      description: "Use our profit leak calculator to see exactly how much you're losing in processing fees."
    },
    {
      step: "2",
      icon: MessageCircle,
      title: "Talk it Through",
      description: "Simple walkthrough with our partners to see how it can simplify your day-to-day operations."
    },
    {
      step: "3",
      icon: Package,
      title: "Get Your Payment System",
      description: "We ship your pre-configured payment system directly to your business, ready to use."
    },
    {
      step: "4",
      icon: Zap,
      title: "Start Processing",
      description: "Plug in and start accepting payments immediately with zero processing fees."
    },
    {
      step: "5",
      icon: DollarSign,
      title: "Keep Your Profits",
      description: "Watch your bottom line grow as you eliminate hidden fees on every transaction."
    }
  ];

  return (
    <section id="how-it-works" className="py-20" style={{ backgroundColor: '#F8FAFC' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium mb-6" style={{ backgroundColor: 'rgba(34, 197, 94, 0.1)', color: '#22C55E' }}>
            <Zap size={16} />
            <span>Simple Process</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#0F172A' }}>
            How It Works — <span style={{ color: '#D4AF37' }}>5 Simple Steps</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Getting started is quick and easy. No complicated setup, no long contracts.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div key={index} className="relative">
                {/* Connector Line */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 -z-10" style={{ backgroundColor: 'rgba(212, 175, 55, 0.3)', width: 'calc(100% - 2rem)' }}></div>
                )}
                
                <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 h-full border border-gray-100">
                  {/* Step Number */}
                  <div 
                    className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-xl mb-4"
                    style={{ backgroundColor: '#D4AF37' }}
                  >
                    {step.step}
                  </div>
                  
                  {/* Icon */}
                  <div 
                    className="w-14 h-14 rounded-xl flex items-center justify-center mb-4"
                    style={{ backgroundColor: 'rgba(11, 31, 58, 0.1)' }}
                  >
                    <IconComponent style={{ color: '#0B1F3A' }} size={28} />
                  </div>
                  
                  <h3 className="text-xl font-bold mb-3" style={{ color: '#0F172A' }}>{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a href="/quick-check">
            <Button 
              className="text-white font-bold text-lg px-10 py-6 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 group"
              style={{ backgroundColor: '#22C55E' }}
            >
              Book My Walkthrough
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default NewHowItWorks;
